export const GET_WATERFALL_GRAPH = 'getWaterfallGraph'
export const GET_COST_GRAPH = 'getCostGraph'
export const GET_CONSOLIDATED_GRAPH = 'getConsolidatedGraph'

export const TAG_WATERFALL_GRAPH = 'WATERFALL_GRAPH'
export const TAG_CONSOLIDATED_GRAPH = 'CONSOLIDATED_GRAPH'
export const TAG_COST_GRAPH = 'COST_GRAPH'

export const SLICE_NAME_ACT_GRAPHS = 'actGraphs'
